// ATTENTION!! This file is auto generated by 'yarn build' and should NOT be changed manually
import { vmsFetch } from './fetch';
export const kiosksGet = vmsFetch
    .path('/locations/{locationId}/kiosks')
    .method("get")
    .create();
export const kiosksPost = vmsFetch
    .path('/locations/{locationId}/kiosks')
    .method("post")
    .create();
export const kioskDelete = vmsFetch
    .path('/locations/{locationId}/kiosks/{kioskId}')
    .method("delete")
    .create();
export const kioskPut = vmsFetch
    .path('/locations/{locationId}/kiosks/{kioskId}')
    .method("put")
    .create();
export const kioskGet = vmsFetch
    .path('/locations/{locationId}/kiosks/{kioskId}')
    .method("get")
    .create();
export const kioskCheckInPost = vmsFetch
    .path('/kiosks/{kioskId}/check-in')
    .method("post")
    .create();
export const kioskHeartbeatPost = vmsFetch
    .path('/kiosks/{kioskId}/heartbeat')
    .method("post")
    .create();
export const kioskActivatePost = vmsFetch
    .path('/kiosks/{kioskId}/activate')
    .method("post")
    .create();
export const visitsGet = vmsFetch
    .path('/locations/{locationId}/visits')
    .method("get")
    .create();
export const visitsPost = vmsFetch
    .path('/locations/{locationId}/visits')
    .method("post")
    .create();
export const visitsDailySummaryGet = vmsFetch
    .path('/locations/{locationId}/visits/daily-summary')
    .method("get")
    .create();
export const visitsBulkUpdatePost = vmsFetch
    .path('/locations/{locationId}/visits/bulk-update')
    .method("post")
    .create();
export const visitsBulkDeletePost = vmsFetch
    .path('/locations/{locationId}/visits/bulk-delete')
    .method("post")
    .create();
export const visitsBulkInvitePost = vmsFetch
    .path('/locations/{locationId}/visits/bulk-invite')
    .method("post")
    .create();
export const visitGet = vmsFetch
    .path('/locations/{locationId}/visits/{visitId}')
    .method("get")
    .create();
export const visitDelete = vmsFetch
    .path('/locations/{locationId}/visits/{visitId}')
    .method("delete")
    .create();
export const visitPut = vmsFetch
    .path('/locations/{locationId}/visits/{visitId}')
    .method("put")
    .create();
export const visitPrintPost = vmsFetch
    .path('/locations/{locationId}/visits/{visitId}/print')
    .method("post")
    .create();
export const visitorPut = vmsFetch
    .path('/locations/{locationId}/visitors/{visitorId}')
    .method("put")
    .create();
export const visitorUploadImagePost = vmsFetch
    .path('/visitors/{visitorId}/upload-image')
    .method("post")
    .create();
export const visitorImageGet = vmsFetch
    .path('/visitors/{visitorId}/image')
    .method("get")
    .create();
export const forgottenCardCodePost = vmsFetch
    .path('/forgotten-card-code')
    .method("post")
    .create();
export const forgottenCardCodeValidatePost = vmsFetch
    .path('/forgotten-card-code/validate')
    .method("post")
    .create();
export const forgottenCardCodeActivatePost = vmsFetch
    .path('/forgotten-card-code/activate')
    .method("post")
    .create();
export const preregistrationGet = vmsFetch
    .path('/pregistration/{preregistrationId}')
    .method("get")
    .create();
export const preregistrationPost = vmsFetch
    .path('/pregistration/{preregistrationId}')
    .method("post")
    .create();
export const outlookEventsPost = vmsFetch
    .path('/outlook-events')
    .method("post")
    .create();
export const outlookAddinGet = vmsFetch
    .path('/outlook-addin')
    .method("get")
    .create();
export const outlookAddinPost = vmsFetch
    .path('/outlook-addin')
    .method("post")
    .create();
export const meetingGet = vmsFetch
    .path('/locations/{locationId}/meetings/{meetingId}')
    .method("get")
    .create();
export const meetingChangeWatcherPut = vmsFetch
    .path('/locations/{locationId}/meetings/{meetingId}/change_watcher')
    .method("put")
    .create();
export const employeesGet = vmsFetch
    .path('/locations/{locationId}/employees')
    .method("get")
    .create();
export const locationsReceptionistsGet = vmsFetch
    .path('/locations/{locationId}/receptionists')
    .method("get")
    .create();
export const locationsReceptionistsPost = vmsFetch
    .path('/locations/{locationId}/receptionists')
    .method("post")
    .create();
export const locationsReceptionistsDelete = vmsFetch
    .path('/locations/{locationId}/receptionists/{userId}')
    .method("delete")
    .create();
export const locationsGet = vmsFetch
    .path('/locations')
    .method("get")
    .create();
export const printersGet = vmsFetch
    .path('/locations/{locationId}/printers')
    .method("get")
    .create();
export const printersSendCommandPost = vmsFetch
    .path('/locations/{locationId}/printers/{printerId}/sendCommand')
    .method("post")
    .create();
export const printersTestPrintPost = vmsFetch
    .path('/locations/{locationId}/printers/{printerId}/testPrint')
    .method("post")
    .create();
export const eventsGet = vmsFetch
    .path('/locations/{locationId}/events')
    .method("get")
    .create();
export const checkAndActivateCardPost = vmsFetch
    .path('/kiosks/activate-card')
    .method("post")
    .create();
export const checkInMetricPost = vmsFetch
    .path('/kiosks/check-in-metric')
    .method("post")
    .create();
export const visitsBulkActivatePost = vmsFetch
    .path('/locations/{locationId}/visits/bulk-activate')
    .method("post")
    .create();
export const accessCardsGet = vmsFetch
    .path('/locations/{locationId}/access-cards')
    .method("get")
    .create();
export const cardLogsPost = vmsFetch
    .path('/card-logs')
    .method("post")
    .create();
//# sourceMappingURL=api.js.map